import React from 'react';
import { Checkbox } from '@h2/ui';
import { Label } from '@h2/ui';
import { useConfigurationStore } from '../../stores/useConfigurationStore';

interface TaskTypeLanguageCheckboxProps {
  title?: string;
  description?: string;
  hideTitle?: boolean;
}

export const TaskTypeLanguageCheckbox: React.FC<TaskTypeLanguageCheckboxProps> = ({
  title,
  description,
  hideTitle = false
}) => {
  const { formData, updateField } = useConfigurationStore();
  const isChecked = formData.languageDependent as boolean || false;

  const handleChange = (checked: boolean) => {
    updateField('languageDependent', checked);
  };

  return (
    <div className="py-2">
      <div className="flex items-center gap-3">
        <Label htmlFor="languageDependent" className="text-sm font-medium cursor-pointer">
          다국어 작업
        </Label>
        <Checkbox
          id="languageDependent"
          checked={isChecked}
          onCheckedChange={handleChange}
        />
      </div>
      <p className="text-xs text-muted-foreground mt-1">
        (번역, 번역검수 등)
      </p>
    </div>
  );
};
